import { useEffect, useState } from 'react'
import { cn } from '#/lib/utils'

// Logos uploaded through the admin live behind /api/tools/logo/:id. Nitro's dev
// middleware treats requests with `sec-fetch-dest: image` as static assets and
// never forwards them to the app handler, so a plain <img src> 404s in dev.
// Fetching the bytes ourselves (sec-fetch-dest: empty) works in dev and prod.
const cache = new Map<string, Promise<string | null>>()
const load = (url: string) => {
  let p = cache.get(url)
  if (!p) {
    p = fetch(url).then(async (r) => (r.ok ? URL.createObjectURL(await r.blob()) : null)).catch(() => null)
    cache.set(url, p)
  }
  return p
}

export function ToolLogo({ src, alt = '', className }: { src: string | null | undefined; alt?: string; className?: string }) {
  const isApi = Boolean(src?.startsWith('/api/'))
  const [blob, setBlob] = useState<string | null>(null)
  useEffect(() => {
    if (!src || !isApi) return
    let live = true
    void load(src).then((u) => live && setBlob(u))
    return () => { live = false }
  }, [src, isApi])
  const url = isApi ? blob : src
  if (!url) return <div aria-hidden className={cn('rounded-lg border bg-muted', className)} />
  return <img src={url} alt={alt} className={cn('rounded-lg border object-contain', className)} />
}
